<template>
  <el-dialog title="Reopen Audit" :close-on-click-modal="false" :visible.sync="visible" width="800px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="138px">
      <el-form-item label="Reopen Reason" v-if="engagementDetail.reopenStatus == 0 && engagementDetail.reopenReason">
        <span>{{ engagementDetail.reopenReason }}</span>
      </el-form-item>
      <el-form-item label="Status" prop="reopenStatus">
        <el-radio-group v-model="dataForm.reopenStatus">
          <el-radio :label="2">Rejected</el-radio>
          <el-radio :label="1">Pass</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Remark" prop="remark">
        <el-input
          v-model="dataForm.remark"
          type="textarea"
          :rows="5"
          :autosize="{ minRows: 4 }"
          resize="none"
          placeholder="Remark"
          v-regexFilter="halfWidthRegex"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    engagementId: {
      type: [String, null],
      require: true,
    },
    engagementDetail: {
      type: Object,
      default: function () {
        return {
          reopenStatus: null,
          reopenReason: null,
        };
      },
    },
  },
  data() {
    return {
      visible: false,
      dataForm: {
        reopenStatus: 1,
        remark: "",
      },
      dataRule: {
        reopenStatus: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  methods: {
    async init() {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post(`/admin/engagementManage/${this.engagementId}/reopenAudit`, this.dataForm)
            .then(res => {
              this.visible = false;
              this.$emit("reOpenAuditFeedback");
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
